import { type ReactNode } from "react";
import { cn } from '@printtat/ui';

interface VariantRowProps {
  isEnabled: boolean;
  isOutOfStock: boolean;
  isDefault: boolean;
  onToggle: () => void;
  onSetDefault: () => void;
  children: ReactNode;
  className?: string;
}

export const VariantRow = ({
  isEnabled,
  isOutOfStock,
  isDefault,
  onToggle,
  onSetDefault,
  children,
  className,
}: VariantRowProps) => (
  <div
    className={cn(
      "group flex items-center gap-2 px-2.5 py-1 transition-colors",
      isOutOfStock && "opacity-50",
      className,
    )}
  >
    {children}
    {isOutOfStock ? (
      <span className="text-[9px] text-[#888]">Out of stock</span>
    ) : (
      <>
        {isEnabled && (
          <button
            onClick={onSetDefault}
            className={cn(
              "text-[9px] flex-shrink-0 transition-colors cursor-pointer select-none",
              isDefault
                ? "text-[#888] font-medium"
                : "text-transparent group-hover:text-[#aaa] hover:!text-[#666]",
            )}
          >
            {isDefault ? "Default" : "Make default"}
          </button>
        )}
        <button
          onClick={onToggle}
          className={cn(
            "w-3.5 h-3.5 rounded border flex items-center justify-center flex-shrink-0 transition-colors cursor-pointer",
            isEnabled
              ? "bg-gray-900 border-gray-900"
              : "border-gray-300 hover:border-gray-400",
          )}
        >
          {isEnabled && (
            <svg width="8" height="8" viewBox="0 0 8 8" fill="none">
              <path d="M1.5 4L3.2 5.7L6.5 2.3" stroke="white" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          )}
        </button>
      </>
    )}
  </div>
);
